import { ISankeyGraph, ISankeyLink } from '../../SankeyChart/interfaces';
import { useMemo } from 'react';
import useCacheLlmRawDataEffect, {
  objectToKvPairs,
} from './useCacheLlmRawDataEffect';

interface IProps {
  analysisId: string;
  sankey: ISankeyGraph;
}

const sankeyLinksToString = (links: ISankeyLink[]): string => {
  return links
    .map((link) => {
      const { targetId, value } = link;
      return objectToKvPairs({
        targetId,
        value,
      });
    })
    .join('; ');
};

const useCacheSankeyLlmRawDataEffect = ({ analysisId, sankey }: IProps) => {
  const rawData = useMemo(() => {
    const ret = ['The Sankey diagram represents the following graph nodes'];
    sankey.nodes.forEach((node) => {
      // a JSON/strigified version of a stripped down node
      const {
        id,
        name,
        fixedValue,
        groupName,
        incomingCount,
        incomingCountFromOther,
        incomingTotalPerSeq,
        outgoingCount,
        sourceLinks,
        targetLinks,
      } = node;
      ret.push(
        objectToKvPairs({
          id,
          name,
          value: fixedValue,
          groupName,
          incomingCount,
          incomingCountFromOther,
          incomingTotalPerSeq,
          outgoingCount,
        }),
      );
      if (sourceLinks.length > 0) {
        ret.push(`   Right side links: ${sankeyLinksToString(sourceLinks)}`);
      }
      if (targetLinks.length > 0) {
        ret.push(`   Left side links: ${sankeyLinksToString(targetLinks)}`);
      }
      ret.push('');
    });
    return ret.join('\n');
  }, [sankey.nodes]);

  useCacheLlmRawDataEffect({ analysisId, rawData });
};

export default useCacheSankeyLlmRawDataEffect;
